export default __webpack_public_path__ + "static/media/05.2542736f.png";